import { PanelResult } from "common/panel/dto/PanelResult";

export const panelFormDefaultValuesGet = (panel?: PanelResult) => {
  if (panel) {
    return {
      datum: panel.datum,
      title: panel.title,
      slug: panel.slug,
      fileName: panel.fileName,
      areas: panel.areas,
    };
  } else {
    return {
      datum: new Date(),
      title: "",
      slug: "",
      fileName: "",
      areas: [],
    };
  }
};
